const orgs = [
  {
    name: 'FEJAR',
    full: 'Federación Española de Jugadores de Azar Rehabilitados',
    phone: '900 200 225',
    web: 'https://fejar.org',
    hours: '24 horas · 7 días a la semana',
    desc: 'Línea de ayuda gratuita y confidencial para personas con problemas de juego y sus familias. Ofrecen orientación, terapia y grupos de apoyo en toda España.',
    icon: 'ri-heart-pulse-line',
    color: '#ef4444',
    free: true,
  },
  {
    name: 'Jugadores Anónimos',
    full: 'Programa de 12 pasos para la recuperación',
    phone: '91 559 09 09',
    web: 'https://jugadores-anonimos.es',
    hours: 'Grupos presenciales en toda España',
    desc: 'Programa de recuperación basado en los 12 pasos, con grupos de apoyo presenciales en más de 50 ciudades españolas. Completamente gratuito y anónimo.',
    icon: 'ri-group-line',
    color: '#06b6d4',
    free: true,
  },
  {
    name: 'DGOJ',
    full: 'Dirección General de Ordenación del Juego',
    phone: null,
    web: 'https://ordenacionjuego.es',
    hours: 'Registro de Autoexclusión (RGIAJ)',
    desc: 'Organismo oficial que gestiona el Registro General de Interdicciones de Acceso al Juego. Puedes solicitar tu autoexclusión de todas las casas online reguladas en España.',
    icon: 'ri-government-line',
    color: '#f59e0b',
    free: true,
  },
  {
    name: 'Jugarbien.es',
    full: 'Portal oficial de juego responsable',
    phone: null,
    web: 'https://jugarbien.es',
    hours: 'Recursos online 24/7',
    desc: 'Portal oficial con información sobre juego responsable, herramientas de autocontrol, test de evaluación y directorio de recursos de ayuda en toda España.',
    icon: 'ri-shield-check-line',
    color: '#00e87a',
    free: true,
  },
];

const limits = [
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Límites de depósito',
    desc: 'Todas las casas reguladas en España permiten establecer límites diarios, semanales o mensuales de depósito. Actívalos en la sección de "Juego Responsable" de tu cuenta.',
  },
  {
    icon: 'ri-time-line',
    title: 'Límites de tiempo de sesión',
    desc: 'Puedes configurar alertas y límites de tiempo de juego. Cuando alcances el límite, la sesión se cerrará automáticamente.',
  },
  {
    icon: 'ri-pause-circle-line',
    title: 'Autoexclusión temporal',
    desc: 'Solicita una pausa de 24 horas, 7 días o 30 días directamente en la casa de apuestas. Durante ese tiempo no podrás acceder a tu cuenta.',
  },
  {
    icon: 'ri-forbid-line',
    title: 'Autoexclusión permanente (RGIAJ)',
    desc: 'A través de la DGOJ puedes solicitar tu inclusión en el Registro de Interdicciones, que te excluye de todas las casas reguladas en España de forma permanente.',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'Bloqueo de publicidad',
    desc: 'Puedes solicitar no recibir comunicaciones comerciales de las casas de apuestas. Es un derecho reconocido por la normativa española de juego.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Realidad check',
    desc: 'Activa las notificaciones de "realidad check" para recibir recordatorios periódicos del tiempo que llevas jugando y el saldo gastado.',
  },
];

export default function ResourcesSection() {
  return (
    <section id="recursos" className="py-20 bg-[#0a0c11]">
      <div className="max-w-[1440px] mx-auto px-6">
        {/* Organizaciones */}
        <div className="flex items-start gap-4 mb-10">
          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#ef4444]/10 border border-[#ef4444]/20 flex-shrink-0">
            <i className="ri-hospital-line text-[#ef4444] text-xl"></i>
          </div>
          <div>
            <p className="text-[#ef4444] text-xs font-semibold uppercase tracking-widest mb-1">Ayuda profesional</p>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2" style={{ fontFamily: "'Syne', sans-serif" }}>
              Organizaciones de Ayuda
            </h2>
            <p className="text-[#a8b2c1] text-sm max-w-2xl">
              Todas estas organizaciones ofrecen ayuda gratuita y confidencial. No estás solo — pedir ayuda es el primer paso más importante.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-16">
          {orgs.map((o) => (
            <div key={o.name} className="bg-[#0d0f14] border border-[#1e2028] rounded-xl p-5 hover:border-[#2a2d3a] transition-colors">
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl" style={{ backgroundColor: `${o.color}15` }}>
                    <i className={`${o.icon} text-base`} style={{ color: o.color }}></i>
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-sm">{o.name}</h3>
                    <p className="text-[#6b7280] text-xs">{o.full}</p>
                  </div>
                </div>
                {o.free && (
                  <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-[#00e87a]/10 text-[#00e87a] whitespace-nowrap flex-shrink-0">
                    Gratuito
                  </span>
                )}
              </div>

              <p className="text-[#a8b2c1] text-xs leading-relaxed mb-4">{o.desc}</p>

              <div className="flex flex-wrap gap-2">
                {o.phone && (
                  <a
                    href={`tel:${o.phone.replace(/\s/g, '')}`}
                    className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/5 border border-[#2a2d3a] text-[#a8b2c1] text-xs font-medium hover:text-white hover:border-[#3a3d4a] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-phone-line text-xs" style={{ color: o.color }}></i>
                    </div>
                    {o.phone}
                  </a>
                )}
                <a
                  href={o.web}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/5 border border-[#2a2d3a] text-[#a8b2c1] text-xs font-medium hover:text-white hover:border-[#3a3d4a] transition-colors cursor-pointer whitespace-nowrap"
                >
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-external-link-line text-xs" style={{ color: o.color }}></i>
                  </div>
                  Visitar web
                </a>
                <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/5 border border-[#1e2028] text-[#6b7280] text-xs whitespace-nowrap">
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-time-line text-xs"></i>
                  </div>
                  {o.hours}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Herramientas de control */}
        <div className="flex items-start gap-4 mb-8">
          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#f59e0b]/10 border border-[#f59e0b]/20 flex-shrink-0">
            <i className="ri-settings-3-line text-[#f59e0b] text-xl"></i>
          </div>
          <div>
            <p className="text-[#f59e0b] text-xs font-semibold uppercase tracking-widest mb-1">Toma el control</p>
            <h2 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: "'Syne', sans-serif" }}>
              Herramientas de Autocontrol
            </h2>
            <p className="text-[#a8b2c1] text-sm max-w-2xl">
              Las casas de apuestas reguladas en España están obligadas a ofrecer estas herramientas. Úsalas proactivamente.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {limits.map((l) => (
            <div key={l.title} className="p-5 bg-[#0d0f14] border border-[#1e2028] rounded-xl hover:border-[#2a2d3a] transition-colors">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#f59e0b]/10 mb-3">
                <i className={`${l.icon} text-[#f59e0b] text-base`}></i>
              </div>
              <h4 className="text-white font-semibold text-sm mb-1.5">{l.title}</h4>
              <p className="text-[#6b7280] text-xs leading-relaxed">{l.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
